import React from 'react';
import {Input} from "../input";

const ContactDetails = props => {
    if (!props) {
        return null
    }

    const {
        textsMapping
    } = props;

    return (
        <section className="checkout-section contact-details">
            <h3 className="checkout-section__title">{textsMapping.contactDetailsTitle}</h3>
            <p>{textsMapping.contactDetailsText}</p>

            <Input
                resourcedTexts={textsMapping}
                inputType="text"
                inputLabel={textsMapping.contactDetailsPhoneLabel}
                placeHolder={textsMapping.contactDetailsPhonePlaceholder}
                path='customerData.personalDetails.phoneNumber'
                required
            />
        </section>
    )
};

export default ContactDetails;